import * as React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@omni/components/components/ProductPage/components/brandLogo/brandLogo.component"
    ).then((module) => ({ default: module.BrandLogoComponent }))
);
